import { AfterViewInit, Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular/main";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import { Router } from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  moduleId: module.id,
  selector: "ag-full-width-grid",
  templateUrl: "./history_detail.component.html",
  styleUrls: ["./history_detail.component.scss"],
})
export class HistoryDetailComponent
  implements ICellRendererAngularComp, AfterViewInit
{
  public params: any;
  public parentRecord: any;
  messages: any;
  loading = false;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  agInit(params: any): void {
    this.parentRecord = params.node.parent.data;
    this.params = params;
  }

  ngAfterViewInit() {}

  refundHappenedEvent() {
    this.params.context.componentParent.methodFromParent();
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/history_detail.component.ts